"use client"
import { useCallback, useEffect, useRef } from "react"
import Realistic from "react-canvas-confetti/dist/presets/realistic"
import { TCanvasConfettiInstance } from "react-canvas-confetti/dist/types"
export default function Confetti() {
  const refAnimationInstance = useRef<TCanvasConfettiInstance | null>(null)

  const getInstance = useCallback(
    (instance: TCanvasConfettiInstance | null) => {
      refAnimationInstance.current = instance
    },
    []
  )

  const makeShot = useCallback(
    (
      particleRatio: number,
      opts: Parameters<TCanvasConfettiInstance>[0] // This gives the correct type for confetti options
    ) => {
      if (refAnimationInstance.current) {
        refAnimationInstance.current({
          ...opts,
          origin: { y: 0.7 },
          particleCount: Math.floor(200 * particleRatio),
        })
      }
    },
    []
  )

  const fire = useCallback(() => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55,
    })

    makeShot(0.2, {
      spread: 60,
    })

    makeShot(0.35, {
      decay: 0.91,
      scalar: 0.8,
      spread: 100,
    })

    makeShot(0.1, {
      decay: 0.92,
      scalar: 1.2,
      spread: 120,
      startVelocity: 25,
    })

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45,
    })
  }, [makeShot])

  useEffect(() => {
    fire()
  }, [fire])

  return (
    <Realistic
      //@ts-ignore
      autorun={{ duration: 3, speed: 0.3 }}
      //@ts-ignore
      refConfetti={getInstance}
      style={{
        height: "100%",
        left: 0,
        pointerEvents: "none",
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 30,
      }}
    />
  )
}
